import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { WriterService } from "../../../services/writer.service";

@Component({
    selector: "app-confirm-deletion-dialog",
    templateUrl: "./confirm-deletion-dialog.component.html",
    styleUrls: ["./confirm-deletion-dialog.component.scss"],
    standalone: false
})
export class ConfirmDeletionDialogComponent {
  recordType: string;
  recordName: string;
  recordId: string;
  vehicleId: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    public dialogRef: MatDialogRef<ConfirmDeletionDialogComponent>,
    private writerService: WriterService
  ) {
    this.recordName = data.recordName;
    this.recordId = data.recordId;
    this.vehicleId = data.vehicleId;
    this.recordType = data.recordType;
  }

  dispatchRequest(): void {
    switch (this.recordType) {
      case "bodystyle":
        this.writerService.deleteBodystyle(this.recordId).subscribe(() => {
          this.dialogRef.close(true);
        });
        break;
      case "propulsion":
        this.writerService.deletePropulsion(this.recordId).subscribe(() => {
          this.dialogRef.close(true);
        });
        break;
      case "vehicle":
        this.dialogRef.close(true);
        break;
    }
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
